import { IconButton, styled } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TextFieldCustom from "components/TextFieldCustom/TextFieldCustom";
import { useToggle } from "hooks/useToggle";

const PasswordFieldUnstyled = ({
  onChange,
  label,
  isError,
  helperText,
  className,
  id,
  name,
  ...props
}) => {
  const { toggle, isOpen } = useToggle(false);

  return (
    <TextFieldCustom
      {...props}
      id={id}
      name={name}
      placeholder="**********"
      label={label}
      onChange={onChange}
      isError={isError}
      helperText={helperText}
      type={isOpen ? "text" : "password"}
      className={className}
      slotProps={{
        input: {
          endAdornment: (
            <IconButton onClick={toggle} edge="end">
              {isOpen ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        },
      }}
    />
  );
};

const PasswordField = styled(PasswordFieldUnstyled)({});
export default PasswordField;
